import React from "react";
import Logo from "../img/navLogo.png";
import {
  AppBar,
  Toolbar,
  Typography,
  Badge,
  Menu,
  MenuItem,
  Grid,
  IconButton,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import MailIcon from "@material-ui/icons/Mail";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { useStyles } from "../styles/mainStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import Store from "../redux/Store";
// import { officeAuth } from "../redux/Login/LoginActionCreators";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import Countdown from "react-countdown";
import { LogOut } from "../redux/Login/LoginActions";
import ChangeActivitiy from "./ChangeActivitiy";
import PwaPromp from "./PwaPromp";
import CustomFlower from "./CustomFlower";
const NavBar = ({ width, setOpen, layoutRef }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [is_mount, set_is_mount] = React.useState(false);
  const [reset_timer, set_reset_timer] = React.useState(true);

  React.useEffect(() => {
    set_is_mount(true);

    return () => {
      set_is_mount(false);
    };
  }, []);

  if (is_mount === true && layoutRef.current !== null) {
    layoutRef.current.onmousemove = () => {
      set_reset_timer(!reset_timer);
    };
    layoutRef.current.onclick = () => {
      set_reset_timer(!reset_timer);
    };
  }

  const history = useHistory();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const clear = () => {
    history.push("/");
    localStorage.clear();
    window.location.reload();
    // Store.dispatch(officeAuth(!Store.getState().loginReducer.officeAuth));
  };

  const Renderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      return (
        <Completionist
          handler={() => {
            LogOut().then((res) => {
              if (!res) return;
              clear();
            });
          }}
        />
      );
    } else {
      return (
        <Typography variant="body1" color="inherit">
          {minutes}:{seconds}
        </Typography>
      );
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  let name;
  let timer;
  try {
    name = JSON.parse(localStorage.profile)?.board_title;
    timer = JSON.parse(localStorage.timeout);
  } catch (error) {
    clear();
  }
  let time = Date.now() + Number(timer) * 1000;
  return (
    <AppBar position="fixed" className={classes.AppBar}>
      <Toolbar className={classes.AppBar} style={{ overflow: "hidden" }}>
        <CustomFlower
          right={-20}
          top={-10}
          scale={0.8}
          scale_bottom_left={0.5}
        />
        <CustomFlower right={20} top={30} scale={0.8} />
        <CustomFlower right={45} top={15} scale={0.7} />
        <CustomFlower right={80} top={5} scale={0.7} />
        <CustomFlower right={100} top={30} scale_bottom_left={0.4} />
        <CustomFlower right={140} top={10} scale={0.7} scale_top_left={0.5} />
        <CustomFlower right={180} top={0} scale={0.7} scale_bottom_left={0.6} />
        <CustomFlower right={175} top={40} scale={0.7} />
        <CustomFlower right={220} top={7} scale={0.7} scale_top_left={0.5} />
        <CustomFlower right={240} top={35} scale={0.7} scale_top_right={0.5} />
        <Grid
          container
          direction="row"
          item
          md={12}
          justifyContent="space-between"
        >
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            item
            style={{ width: "fit-content" }}
          >
            <div
              style={{
                display: "flex",
                width: 300,

                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <img
                src={Logo}
                alt="logo"
                width={50}
                height={50}
                style={{ borderRadius: "15px", zIndex: 15 }}
              />
              <Typography style={{ marginRight: 8, zIndex: 15 }} variant="h5">
                پرینتر همراه
              </Typography>

              {width < 1280 ? (
                <IconButton
                  onClick={() => {
                    setOpen(true);
                  }}
                  style={{ color: "white" }}
                >
                  {<MenuIcon />}
                </IconButton>
              ) : null}
            </div>
          </Grid>

          <Grid
            item
            container
            alignItems="center"
            justifyContent="flex-end"
            xs={12}
            sm={6}
            style={{}}
          >
            <Grid item style={{}}>
              <Countdown date={time} renderer={Renderer} key={reset_timer} />
            </Grid>
            <PwaPromp />
            <Badge badgeContent={0} style={{ margin: "0 8px" }} color="primary">
              <MailIcon />
            </Badge>
            <Badge badgeContent={0} color="error">
              <NotificationsIcon />
            </Badge>
            <ChangeActivitiy offline={localStorage.offline} />
            <Typography
              variant="subtitle2"
              onClick={handleClick}
              style={{ cursor: "pointer" }}
            >
              {name !== undefined ? name : clear()}
            </Typography>
            <IconButton size="small" onClick={handleClick}>
              <ExpandMoreIcon style={{ color: "white" }} />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() => {
                  handleClose();
                  history.push("/profile/personal-info");
                }}
              >
                پروفایل من
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleClose();
                  LogOut().then((res) => {
                    if (!res) return;
                    clear();
                  });
                }}
              >
                خروج از حساب کاربری
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

const mapStateToProps = (props) => {
  const { OrderReducer } = props;
  const { currentOffice } = OrderReducer;

  return { currentOffice };
};

export default connect(mapStateToProps)(NavBar);

const Completionist = ({ handler }) => {
  handler();
  return null;
};
